function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-0.523 0.175)"
}, React.createElement("g", {
  transform: "translate(51.749 0.635)"
}, React.createElement("path", {
  d: "M81.291,162.549a81.274,81.274,0,1,1,81.291-81.274A81.283,81.283,0,0,1,81.291,162.549Z",
  transform: "translate(33.961 33.858)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62,
  strokeDasharray: 12.15,
  opacity: 0.6
}), React.createElement("path", {
  d: "M115.137,230.227A115.114,115.114,0,1,1,230.274,115.114,115.125,115.125,0,0,1,115.137,230.227Z",
  transform: "translate(0)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62,
  strokeDasharray: 12.15,
  opacity: 0.6
})), React.createElement("path", {
  d: "M0,5.837,12.535,0,6.7,12.532Z",
  transform: "translate(69.51 127.854) rotate(22)",
  fill: "#f5f5f5"
}), React.createElement("path", {
  d: "M0,5.837,12.535,0,6.7,12.532,0,5.837Z",
  transform: "translate(69.51 127.854) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,10.592,10.594,0,27.432,16.834,16.838,27.427Z",
  transform: "translate(32.762 132.006) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,10.592,10.594,0,27.432,16.834,16.838,27.427,0,10.592Z",
  transform: "translate(32.762 132.006) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,2.613,2.614,0l24.3,24.3L24.3,26.909Z",
  transform: "translate(41.233 128.809) rotate(22)",
  fill: "#f5f5f5"
}), React.createElement("path", {
  d: "M0,2.613,2.614,0l24.3,24.3L24.3,26.909,0,2.613Z",
  transform: "translate(41.233 128.809) rotate(22)",
  fill: "#f0f2f5",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,9.808,9.81,0,38.981,29.165l-9.81,9.808Z",
  transform: "translate(47.073 161.356) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,9.808,9.81,0,38.981,29.165l-9.81,9.808L0,9.808Z",
  transform: "translate(47.073 161.356) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,1.811,1.811,0l13.94,13.936-1.812,1.811Z",
  transform: "translate(47.198 134.852) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.811,1.811,0l13.94,13.936-1.812,1.811L0,1.811Z",
  transform: "translate(47.198 134.852) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,4.2,4.2,0l.943.943-4.2,4.2Z",
  transform: "translate(51.983 134.836) rotate(22)",
  fill: "#f5f5f5"
}), React.createElement("path", {
  d: "M0,4.2,4.2,0l.943.943-4.2,4.2L0,4.2Z",
  transform: "translate(51.983 134.836) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,4.2,4.2,0l.943.943-4.2,4.2Z",
  transform: "translate(56.41 145.262) rotate(22)",
  fill: "#f5f5f5"
}), React.createElement("path", {
  d: "M0,4.2,4.2,0l.943.943-4.2,4.2L0,4.2Z",
  transform: "translate(56.41 145.262) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M.943,0l4.2,4.2L4.2,5.138,0,.943Z",
  transform: "translate(46.577 161.93) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M.943,0l4.2,4.2L4.2,5.138,0,.943.943,0Z",
  transform: "translate(46.577 161.93) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,6.328.825,0,17.663,16.835l-6.329.825Z",
  transform: "translate(28.029 141.518) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,6.328.825,0,17.663,16.835l-6.329.825L0,6.328Z",
  transform: "translate(28.029 141.518) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M4.541.963,0,0,16.838,16.835l-.963-4.54Z",
  transform: "translate(21.809 144.791) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M4.541.963,0,0,16.838,16.835l-.963-4.54L4.541.963Z",
  transform: "translate(21.809 144.791) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M3.941,0,0,.737,5.02,5.756l.737-3.941Z",
  transform: "translate(19.745 147.308) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M3.941,0,0,.737,5.02,5.756l.737-3.941L3.941,0Z",
  transform: "translate(19.745 147.308) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M3.941,0,0,.737,5.02,5.756l.737-3.941Z",
  transform: "translate(24.688 158.949) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M3.941,0,0,.737,5.02,5.756l.737-3.941L3.941,0Z",
  transform: "translate(24.688 158.949) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,1.261,1.261,0,5.327,4.064,4.065,5.326Z",
  transform: "translate(50.008 135.496) rotate(22)",
  fill: "#f0f2f5"
}), React.createElement("path", {
  d: "M0,1.261,1.261,0,5.327,4.064,4.065,5.326,0,1.261Z",
  transform: "translate(50.008 135.496) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,1.261,1.261,0,5.327,4.064,4.065,5.326Z",
  transform: "translate(54.448 145.951) rotate(22)",
  fill: "#f0f2f5"
}), React.createElement("path", {
  d: "M0,1.261,1.261,0,5.327,4.064,4.065,5.326,0,1.261Z",
  transform: "translate(54.448 145.951) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,1.883,1.884,0,3.916,2.032,2.033,3.915Z",
  transform: "translate(45.415 159.192) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.883,1.884,0,3.916,2.032,2.033,3.915,0,1.883Z",
  transform: "translate(45.415 159.192) rotate(22)",
  fill: "#f5f5f5",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M8.926,24.39C1.415,16.882-1.706,7.426.913,1.542c.433-.973,1.6-2.78,4.117-.26L31.858,28.105c2.3,2.3.894,3.862-.078,4.295C25.895,35.02,16.436,31.9,8.926,24.39Z",
  transform: "translate(60.148 115.917) rotate(22)",
  fill: "#f5f5f5"
}), React.createElement("path", {
  d: "M8.926,24.39C1.415,16.882-1.706,7.426.913,1.542c.433-.973,1.6-2.78,4.117-.26L31.858,28.105c2.3,2.3.894,3.862-.078,4.295C25.895,35.02,16.436,31.9,8.926,24.39Z",
  transform: "translate(60.148 115.917) rotate(22)",
  fill: "#f0f2f5",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,1.261,1.261,0,11.8,10.534,10.536,11.8Z",
  transform: "translate(55.903 134.194) rotate(22)",
  fill: "#f0f2f5"
}), React.createElement("path", {
  d: "M0,1.261,1.261,0,11.8,10.534,10.536,11.8,0,1.261Z",
  transform: "translate(55.903 134.194) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M3.328,3.327a1.949,1.949,0,1,1,0-2.757,1.95,1.95,0,0,1,0,2.757",
  transform: "translate(80.542 129.805) rotate(22)",
  fill: "#a3b1bf"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(54.888 167.691) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(54.888 167.691) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(55.877 170.019) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(55.877 170.019) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(56.865 172.347) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(56.865 172.347) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(57.854 174.675) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(57.854 174.675) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(52.739 168.603) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(52.739 168.603) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(53.728 170.931) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(53.728 170.931) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(54.716 173.259) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(54.716 173.259) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(55.705 175.587) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(55.705 175.587) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(50.59 169.515) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(50.59 169.515) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(51.578 171.843) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(51.578 171.843) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(52.567 174.171) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(52.567 174.171) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(53.555 176.499) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(53.555 176.499) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(48.441 170.427) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(48.441 170.427) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(49.429 172.755) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(49.429 172.755) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(50.418 175.083) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(50.418 175.083) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(51.406 177.411) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(51.406 177.411) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(46.291 171.339) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(46.291 171.339) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(47.28 173.667) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(47.28 173.667) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(48.268 175.995) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(48.268 175.995) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(49.257 178.323) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(49.257 178.323) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(60.065 179.883) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(60.065 179.883) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(61.054 182.212) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(61.054 182.212) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(62.042 184.54) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(62.042 184.54) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(63.031 186.868) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(63.031 186.868) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(57.916 180.795) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(57.916 180.795) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(58.905 183.124) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(58.905 183.124) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(59.893 185.452) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(59.893 185.452) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(60.882 187.78) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(60.882 187.78) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(55.767 181.707) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(55.767 181.707) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(56.755 184.036) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(56.755 184.036) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(57.744 186.364) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(57.744 186.364) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(58.732 188.692) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(58.732 188.692) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(53.618 182.62) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(53.618 182.62) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(54.606 184.948) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(54.606 184.948) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(55.595 187.276) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(55.595 187.276) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(56.583 189.604) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(56.583 189.604) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(51.468 183.532) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(51.468 183.532) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(52.457 185.86) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(52.457 185.86) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(53.445 188.188) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(53.445 188.188) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(54.434 190.516) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(54.434 190.516) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(65.242 192.076) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(65.242 192.076) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(66.231 194.404) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(66.231 194.404) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(67.219 196.732) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(67.219 196.732) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(68.208 199.061) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(68.208 199.061) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(63.093 192.988) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(63.093 192.988) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(64.082 195.316) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(64.082 195.316) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(65.07 197.645) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(65.07 197.645) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(66.059 199.973) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(66.059 199.973) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(60.944 193.9) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(60.944 193.9) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(61.932 196.228) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(61.932 196.228) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(62.921 198.557) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(62.921 198.557) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(63.909 200.885) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(63.909 200.885) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(58.795 194.812) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(58.795 194.812) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(59.783 197.14) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(59.783 197.14) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(60.772 199.469) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(60.772 199.469) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(61.76 201.797) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(61.76 201.797) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(56.645 195.724) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(56.645 195.724) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(57.634 198.053) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(57.634 198.053) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(58.622 200.381) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(58.622 200.381) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1Z",
  transform: "translate(59.611 202.709) rotate(22)",
  fill: "rgba(163,177,191,0.6)"
}), React.createElement("path", {
  d: "M1.1,2.2,0,1.1,1.1,0,2.2,1.1,1.1,2.2Z",
  transform: "translate(59.611 202.709) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M29.171,38.973l9.81-9.808L9.81,0,0,9.808Z",
  transform: "translate(15.123 86.107) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M5.139,4.2.943,0,0,.943l4.2,4.2Z",
  transform: "translate(33.068 130.113) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M5.139,4.2.943,0,0,.943l4.2,4.2L5.139,4.2Z",
  transform: "translate(33.068 130.113) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M2.033,3.915,3.916,2.032,1.884,0,0,1.883Z",
  transform: "translate(34.907 134.443) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M2.033,3.915,3.916,2.032,1.884,0,0,1.883,2.033,3.915Z",
  transform: "translate(34.907 134.443) rotate(22)",
  fill: "#fff",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(36.32 123.959) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(36.32 123.959) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(35.331 121.63) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(35.331 121.63) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(34.343 119.302) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(34.343 119.302) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(33.354 116.974) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(33.354 116.974) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(34.171 124.871) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(34.171 124.871) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(33.182 122.542) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(33.182 122.542) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(32.194 120.214) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(32.194 120.214) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(31.205 117.886) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(31.205 117.886) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(32.022 125.783) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(32.022 125.783) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(31.033 123.454) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(31.033 123.454) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(30.044 121.126) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(30.044 121.126) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(29.056 118.798) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(29.056 118.798) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(29.872 126.695) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(29.872 126.695) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(28.884 124.367) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(28.884 124.367) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(27.895 122.038) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(27.895 122.038) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(26.907 119.71) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(26.907 119.71) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(27.723 127.607) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(27.723 127.607) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(26.735 125.279) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(26.735 125.279) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(25.746 122.95) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(25.746 122.95) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(24.757 120.622) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(24.757 120.622) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(31.143 111.766) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(31.143 111.766) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(30.154 109.438) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(30.154 109.438) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(29.166 107.109) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(29.166 107.109) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(28.177 104.781) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(28.177 104.781) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(28.994 112.678) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(28.994 112.678) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(28.005 110.35) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(28.005 110.35) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(27.017 108.022) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(27.017 108.022) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(26.028 105.693) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(26.028 105.693) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(26.844 113.59) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(26.844 113.59) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(25.856 111.262) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(25.856 111.262) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(24.867 108.934) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(24.867 108.934) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(23.879 106.605) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(23.879 106.605) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(24.695 114.502) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(24.695 114.502) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(23.707 112.174) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(23.707 112.174) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(22.718 109.846) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(22.718 109.846) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(21.73 107.517) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(21.73 107.517) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(22.546 115.414) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(22.546 115.414) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(21.558 113.086) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(21.558 113.086) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(20.569 110.758) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(20.569 110.758) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(19.581 108.429) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(19.581 108.429) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(25.966 99.573) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(25.966 99.573) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(24.977 97.245) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(24.977 97.245) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(23.989 94.917) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(23.989 94.917) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(23 92.589) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(23 92.589) rotate(22)",
  fill: "#b2beca"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(23.817 100.485) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(23.817 100.485) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(22.828 98.157) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(22.828 98.157) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(21.84 95.829) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(21.84 95.829) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(20.851 93.501) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(20.851 93.501) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(21.667 101.397) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(21.667 101.397) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(20.679 99.069) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(20.679 99.069) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(19.69 96.741) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(19.69 96.741) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(18.702 94.413) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(18.702 94.413) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(19.518 102.309) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(19.518 102.309) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(18.53 99.981) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(18.53 99.981) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(17.541 97.653) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(17.541 97.653) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(16.553 95.325) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(16.553 95.325) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(17.369 103.221) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(17.369 103.221) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(16.381 100.893) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(16.381 100.893) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(15.392 98.565) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(15.392 98.565) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0Z",
  transform: "translate(14.404 96.237) rotate(22)",
  fill: "rgba(163,177,191,0.8)"
}), React.createElement("path", {
  d: "M0,1.1,1.1,2.2,2.2,1.1,1.1,0,0,1.1Z",
  transform: "translate(14.404 96.237) rotate(22)",
  fill: "none"
}), React.createElement("path", {
  d: "M2.943,4.473C.94,2.47-.342.5.081.081S2.47.94,4.474,2.943s3.285,3.97,2.863,4.393S4.947,6.476,2.943,4.473Z",
  transform: "translate(86.943 123.957) rotate(22)",
  fill: "#f5f5f5"
}), React.createElement("path", {
  d: "M2.943,4.473C.94,2.47-.342.5.081.081S2.47.94,4.474,2.943s3.285,3.97,2.863,4.393S4.947,6.476,2.943,4.473Z",
  transform: "translate(86.943 123.957) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M5.881,8.937c-4-4-6.565-7.932-5.72-8.776S4.936,1.877,8.939,5.88s6.565,7.932,5.721,8.777S9.885,12.941,5.881,8.937Z",
  transform: "translate(90.27 116.858) rotate(22)",
  fill: "#f5f5f5"
}), React.createElement("path", {
  d: "M5.881,8.937c-4-4-6.565-7.932-5.72-8.776S4.936,1.877,8.939,5.88s6.565,7.932,5.721,8.777S9.885,12.941,5.881,8.937Z",
  transform: "translate(90.27 116.858) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M7.882,11.978C2.517,6.613-.916,1.347.216.216s6.4,2.3,11.764,7.665,8.8,10.63,7.666,11.762S13.248,17.342,7.882,11.978Z",
  transform: "translate(96.625 110.29) rotate(22)",
  fill: "rgba(245,245,245,0.35)"
}), React.createElement("path", {
  d: "M7.882,11.978C2.517,6.613-.916,1.347.216.216s6.4,2.3,11.764,7.665,8.8,10.63,7.666,11.762S13.248,17.342,7.882,11.978Z",
  transform: "translate(96.625 110.29) rotate(22)",
  fill: "none",
  stroke: "#a3b1bf",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.62
}), React.createElement("path", {
  d: "M3.28,5.631C1.392,5.493,0,5.018,0,4.453S1.389,3.414,3.274,3.276C3.408,1.39,3.866,0,4.411,0s1,1.39,1.137,3.276c1.885.138,3.275.613,3.275,1.178S7.43,5.493,5.541,5.631C5.4,7.474,4.948,8.822,4.411,8.822S3.422,7.474,3.28,5.631Z",
  transform: "translate(43.08 54.777) rotate(20)",
  fill: "rgba(163,177,191,0.4)",
  opacity: 0.85
}), React.createElement("path", {
  d: "M4.453,6.01l-.239.263a1.655,1.655,0,0,1-2.853-.818L1.3,5.106.975,4.961a1.655,1.655,0,0,1-.1-2.966l.312-.168.039-.353A1.655,1.655,0,0,1,4.011.459L4.268.7,4.614.632A1.655,1.655,0,0,1,6.442,2.971l-.154.319.176.308A1.655,1.655,0,0,1,4.8,6.058Z",
  transform: "translate(76.598 218.329)",
  fill: "rgba(163,177,191,0.4)"
}), React.createElement("path", {
  d: "M1.723,3.319h0a1.176,1.176,0,0,1-1.5-1.093h0A1.176,1.176,0,0,1,.792.457h0a1.176,1.176,0,0,1,1.86,0h0a1.176,1.176,0,0,1,.575,1.769h0a1.176,1.176,0,0,1-1.5,1.093Z",
  transform: "translate(293.112 78.697) rotate(-3)",
  fill: "rgba(163,177,191,0.4)"
}), React.createElement("path", {
  d: "M3.724,6.785l-.508.267a1.655,1.655,0,0,1-2.4-1.745l.1-.565-.41-.4a1.655,1.655,0,0,1,.917-2.823l.567-.082L2.24.922a1.655,1.655,0,0,1,2.968,0l.254.515.567.082a1.655,1.655,0,0,1,.917,2.823l-.41.4.1.565a1.655,1.655,0,0,1-2.4,1.745Z",
  transform: "translate(65.767 18.799) rotate(19)",
  fill: "rgba(163,177,191,0.4)"
}), React.createElement("path", {
  d: "M1.61,5.362,1.247,5.27a1.655,1.655,0,0,1-.617-2.9l.294-.232L.9,1.763A1.655,1.655,0,0,1,3.47.279l.311.208L4.129.348A1.655,1.655,0,0,1,6.334,2.333l-.1.36.239.287A1.655,1.655,0,0,1,5.264,5.693l-.373.015-.2.316a1.655,1.655,0,0,1-2.952-.31Z",
  transform: "translate(268.653 203.045)",
  fill: "rgba(163,177,191,0.4)"
}), React.createElement("path", {
  d: "M1.723,3.319h0a1.176,1.176,0,0,1-1.5-1.093h0A1.176,1.176,0,0,1,.792.457h0a1.176,1.176,0,0,1,1.86,0h0a1.176,1.176,0,0,1,.575,1.769h0a1.176,1.176,0,0,1-1.5,1.093Z",
  transform: "matrix(0.978, -0.208, 0.208, 0.978, 297.6, 96.937)",
  fill: "rgba(163,177,191,0.4)"
}), React.createElement("ellipse", {
  cx: 40.119,
  cy: 40.111,
  rx: 40.119,
  ry: 40.111,
  transform: "translate(126.629 70.213)",
  fill: "rgba(163,177,191,0.66)"
}), React.createElement("path", {
  d: "M8.42,28.9a2.432,2.432,0,0,1-1.708-.675,2.265,2.265,0,0,1-.675-1.707,2.132,2.132,0,0,1,.675-1.667,2.268,2.268,0,0,1,1.708-.675,2.346,2.346,0,0,1,1.747.675,2.272,2.272,0,0,1,.675,1.667,2.189,2.189,0,0,1-.715,1.707A2.431,2.431,0,0,1,8.42,28.9Zm1.589-7.5H6.831v-.913a7.922,7.922,0,0,1,.715-3.453,16.554,16.554,0,0,1,4.011-4.6,17.742,17.742,0,0,0,1.35-1.429A4.9,4.9,0,0,0,14.1,7.859a5.01,5.01,0,0,0-1.35-3.691A5.1,5.1,0,0,0,8.856,2.778a6.436,6.436,0,0,0-2.591.481A4.414,4.414,0,0,0,4.448,4.723,7.134,7.134,0,0,0,3.137,9.288H0A11.416,11.416,0,0,1,.576,5.537,8.014,8.014,0,0,1,2.343,2.619,7.57,7.57,0,0,1,5.2.655,10.423,10.423,0,0,1,9.015,0a8.591,8.591,0,0,1,6.116,2.1,7.254,7.254,0,0,1,2.224,5.6,7.506,7.506,0,0,1-1.51,4.644A39.8,39.8,0,0,1,12.629,15.4a8.193,8.193,0,0,0-1.866,2.183,5.528,5.528,0,0,0-.754,2.9v.913Z",
  transform: "translate(158.226 96.261)",
  fill: "#fff"
}), React.createElement("path", {
  d: "M12.34,11.834C16.3,9.548,23.488,6.855,21.2,2.9S10.5-.489,6.544,1.8s-8.186,9-5.9,12.964,7.735-.641,11.7-2.927",
  transform: "translate(139.863 79.034)",
  fill: "#fafafa"
}), React.createElement("ellipse", {
  cx: 3.312,
  cy: 3.311,
  rx: 3.312,
  ry: 3.311,
  transform: "translate(166.88 75.175)",
  fill: "#fafafa"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 301.152,
    height: 231.847,
    viewBox: "0 0 301.152 231.847"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/404.7bb0988d.svg";
export { SvgComponent as ReactComponent };